export const ATTRIBUTE_CHART_CONFIGURATION_MODAL_NAME = 'ATTRIBUTE_CHART_CONFIGURATION_MODAL';
export const DEFAULT_CHART_DATA_POLLING_INTERVAL = 5000;
